import Axios from "../../initializers/axios"
import { inodePath } from "./util"
import { driveApi, driveFilesApi, foldersApi } from "store/api"

export default {
  setCurrentInode({ commit, dispatch, state, getters }, inodeId) {
    commit("showUploader", false)
    commit("setCurrentInodeId", inodeId)
    if (inodeId && (!state.inodes || !state.inodes[inodeId])) {
      dispatch("loadInode", inodeId)
    }
  },
  async loadInode({ commit, getters }, inode_id) {
    try {
      commit("loader/SET_ERROR", false, { root: true })
      commit("setLoading", true)
      const { data } = await foldersApi.getFolder(inode_id)
      commit("updateInodes", inodePath(data))
    } catch (err: any) {
      switch (err.response.status) {
        case 404:
          commit("loader/SET_ERROR", err, { root: true })
          console.log(err)
          break
        case 500:
          commit("loader/SET_ERROR", err, { root: true })
          console.log(err)
          break
        default:
          console.error(err.response.status, err)
          commit("loader/SET_ERROR", err, { root: true })
      }
    } finally {
      commit("setLoading", false)
    }
  },
  async loadCategories({ commit }) {
    try {
      commit("setLoading", true)
      commit("loader/SET_ERROR", false, { root: true })
      const { data } = await driveApi.getCategories()
      commit("updateInodes", data.results)
      commit("setCreateCategoryUrl", data.create_category_url)
    } catch (err) {
      console.log(err)
      commit("loader/SET_ERROR", err, { root: true })
    } finally {
      commit("setLoading", false)
    }
  },
  async createFolder({ commit, getters, state }, formData) {
    try {
      commit("setLoading", true)
      commit("loader/SET_ERROR", false, { root: true })
      const url = getters.currentFolder
        ? getters.currentFolder.create_subfolder_url
        : state.createCategoryUrl
      const { data: folder } = await Axios.post(url, formData)
      commit("updateInodes", [folder])
      return folder
    } catch (err) {
      console.log(err)
      commit("loader/SET_ERROR", err, { root: true })
    } finally {
      commit("setLoading", false)
    }
  },
  async updateInode({ commit, dispatch, getters }, { inode, formData }) {
    const { data } = await Axios.put(inode.update_url, formData)
    commit("updateInodes", [data])
  },
  async destroyFolder({ commit }, folder) {
    try {
      commit("setLoading", true)
      commit("loader/SET_ERROR", false, { root: true })
      await foldersApi.deleteFolder(folder.id)
      commit("removeInodes", [folder])
      commit("setSuccess", "Ordner gelöscht.")
    } catch (err) {
      console.log(err)
      commit("loader/SET_ERROR", err, { root: true })
    } finally {
      commit("setLoading", false)
    }
  },
  async destroyDriveFile({ commit }, driveFile) {
    try {
      commit("setLoading", true)
      commit("loader/SET_ERROR", false, { root: true })
      await driveFilesApi.deleteDriveFile(driveFile.id)
      commit("removeInodes", [driveFile])
      commit("setSuccess", "Ordner gelöscht.")
    } catch (err) {
      console.log(err)
      commit("loader/SET_ERROR", err, { root: true })
    } finally {
      commit("setLoading", false)
    }
  },
  async createFile({ commit, getters }, formData) {
    const { data: driveFile } = await driveFilesApi.createDriveFile(formData)
    commit("updateInodes", [driveFile])
    return driveFile
  },
}
